import { getDataFromLocalStorage } from 'services/local-storage';
import { StorageType, FeatureId } from 'common/enum';
import { uniqBy } from 'lodash';

const sideMenuItemNewBooking = {
  key: 'newBooking',
  icon: 'plus-square',
  title: 'PEM',
  path: '/new-booking',
};

const sideMenuItemPosition = {
  key: 'positions',
  icon: 'environment',
  title: 'Positions',
  path: '/position',
};

const sideMenuItemManageBooking = {
  key: 'manageBooking',
  icon: 'setting',
  title: 'Manage Bookings',
  path: '/manage-booking',
};

const sideMenuItemNewBookingAMC360 = {
  key: 'newBookingAMC360',
  icon: 'plus-square',
  title: 'AMC360',
  path: '/amc360-booking',
};

const sideMenuItemPatient = {
  key: 'patients',
  icon: 'user',
  title: 'Candidates/Patients',
  path: '/patient',
};

const sideMenuItemPackage = {
  key: 'packages',
  icon: 'inbox',
  title: 'Packages',
  path: '/package',
};

const sideMenuItemProjectIdentification = {
  key: 'projectIdentification',
  icon: 'project',
  title: 'Project Identification',
  path: '/project-identification',
};

const sideMenuItemManageLogin = {
  key: 'manageLogin',
  icon: 'user',
  title: 'Login Management',
  path: '/manage-login',
};

class RoleMenuItem {
  constructor() {
    this.menuItemAppliedRole = null;
    this.internalRole = this.getLocalStorageRole();
    this.projectIdentificationRole = false;
    this.isError = false;
  }

  getLocalStorageRole = () => {
    try {
      const roleList = getDataFromLocalStorage(StorageType.AuthInfo)
        .permissions;
      return roleList;
    } catch (error) {
      this.isError = true;
      return null;
    }
  };

  checkSiteRole = () => {
    if (this.internalRole && this.internalRole.length !== 0 && !this.isError) {
      let sideMenuItemListNormal = [];
      let sideMenuItemMakeBooking = {
        key: 'make-booking',
        icon: 'plus-square',
        title: 'Make Booking',
        path: 'make-booking',
        hasChildren: false,
        children: [],
      };

      this.internalRole.forEach(element => {
        switch (element.featureId) {
          case FeatureId.BOOKING_PEM:
            sideMenuItemMakeBooking.children.push(sideMenuItemNewBooking);
            sideMenuItemMakeBooking.hasChildren = true;
            break;
          case FeatureId.BOOKING_AMC360:
            sideMenuItemMakeBooking.children.push(sideMenuItemNewBookingAMC360);
            sideMenuItemMakeBooking.hasChildren = true;
            break;
          //Requirement,
          //just 1 in 2 roles manage patient or organization manage patient will show the patient menu
          case FeatureId.CANDIDATE:
            sideMenuItemListNormal.push(sideMenuItemPatient);
            break;
          case FeatureId.ORGANISATION_CANDIDATE:
            sideMenuItemListNormal.push(sideMenuItemPatient);
            break;
          case FeatureId.PACKAGE:
            sideMenuItemListNormal.push(sideMenuItemPackage);
            break;
          case FeatureId.MANAGE_BOOKING:
            sideMenuItemListNormal.push(sideMenuItemManageBooking);
            break;
          case FeatureId.POSITION:
            sideMenuItemListNormal.push(sideMenuItemPosition);
            break;
          case FeatureId.PROJECT_IDENTIFICATION:
            sideMenuItemListNormal.push(sideMenuItemProjectIdentification);
            break;
          case FeatureId.MANAGE_LOGIN:
            sideMenuItemListNormal.push(sideMenuItemManageLogin);
            break;
          default:
            break;
        }
        if (sideMenuItemMakeBooking.hasChildren) {
          sideMenuItemListNormal.push(sideMenuItemMakeBooking);
        }

        this.menuItemAppliedRole = uniqBy(sideMenuItemListNormal, e => {
          return e.key;
        });
      });
    }
  };
}

function getMenuItemAppliedRole() {
  const menuItemAppliedRole = new RoleMenuItem();
  if (menuItemAppliedRole.isError) {
    return null;
  } else {
    menuItemAppliedRole.checkSiteRole();
    return menuItemAppliedRole.menuItemAppliedRole;
  }
}

export { getMenuItemAppliedRole };
